<script>
import Repositories from '@/repositories';
const ImportationsRepository = Repositories.get('importations');

import * as XLSX from 'xlsx';

import SelectFromListModal from '@/components/widgets/modals/select-from-list';

export default {
  components: {
    SelectFromListModal,
  },
  data() {
    return {
      importType: 0,
      loadingImportWorkOrders: false,
      loadingImportItems: false,
    };
  },
  methods: {
    importWorkOrders() {
      this.importType = 1;
      this.$refs.file.click();
    },
    importItems() {
      this.importType = 2;
      this.$refs.file.click();
    },
    async fileToBlob(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsArrayBuffer(file);
      });
    },
    async uploadFile() {
      try {
        let uploadedFiles = this.$refs.file.files;
        if (uploadedFiles != undefined) {
          let sheets = [];

          /* Add the form data we need to submit */
          let formData = new FormData();
          for (let i = 0; i < uploadedFiles.length; ++i) {
            let file = uploadedFiles[i];
            let blob = await this.fileToBlob(file);
            let excel = XLSX.read(blob);
            sheets = [...new Set([...sheets, ...excel.SheetNames])];
            formData.append('file', file);
          }

          if (sheets.length > 1) {
            let { canceled, selected } =
              await this.$refs.SelectSheetsModal.show(sheets);

            if (canceled) {
              sheets = [];
            } else {
              sheets = selected;
            }
          }

          if (sheets.length > 0) {
            for (let sheet of sheets) {
              formData.append('sheets', sheet);
            }

            if (this.importType == 1) {
              this.loadingImportWorkOrders = true;
              await ImportationsRepository.actions.workOrdersImport(
                formData,
                sheets
              );
            } else if (this.importType == 2) {
              this.loadingImportItems = true;
              await ImportationsRepository.actions.itemsImport(
                formData,
                sheets
              );
            }
          }

          this.$toast.successToast(this.$t('general.success'));
        }
      } catch {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.loadingImportWorkOrders = false;
        this.loadingImportItems = false;
        this.importType = 0;
        this.$refs.file.value = null;
      }
    },
  },
};
</script>

<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h4>{{ $t('importations.importations') }}</h4>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <b-button
            block
            variant="primary"
            @click="importWorkOrders"
            :disabled="loadingImportItems || loadingImportWorkOrders"
          >
            <span v-if="loadingImportWorkOrders">
              <i
                class="fas fa-spinner fa-spin text-warning ml-2 mr-2"
                style="font-size: 1.3em"
              >
              </i>
            </span>
            <span v-else>
              {{ $t('importations.importWorkOrders') }}
            </span>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            block
            variant="primary"
            @click="importItems"
            :disabled="loadingImportItems || loadingImportWorkOrders"
          >
            <span v-if="loadingImportItems">
              <i
                class="fas fa-spinner fa-spin text-warning ml-2 mr-2"
                style="font-size: 1.3em"
              >
              </i>
            </span>
            <span v-else>
              {{ $t('importations.importItems') }}
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <input @change="uploadFile" ref="file" type="file" hidden multiple />

    <SelectFromListModal
      id="select-sheets-modal"
      ref="SelectSheetsModal"
      :title="$t('importations.sheets')"
    />
  </div>
</template>
